import { TRACKING_EVENTS } from "../../../../../Utils/GAEvents/gaEventsConstants";
import { handleRequestToCallback } from "../../../utils/common";
import { SLIDER_DATA } from "../../../utils/constant";
import { CUSOMER_SUPPORT_CONTACT_DETAILS } from "../../RequestToCallback/utils/constants";

const BusinessTools = ({ sendPostPurchaseDataToGAEvent }) => {

  const requestToCallbackBtnClick = () => {
    sendPostPurchaseDataToGAEvent(TRACKING_EVENTS.postPurchaseRequestToCallback);
    handleRequestToCallback();
  };

  return (
    <div className="tw-bg-blue-two tw-p-[64px]">
      <section className="tw-mb-[66px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-jakarta">
        <span className="tw-text-[1.25rem] tw-font-semibold">Run your business like a pro</span>
        <span className="tw-text-[2.625rem] tw-font-bold">Get more done with</span>
        <span className="tw-text-[2.625rem] tw-font-bold">professional business tools</span>
      </section>
      <section className="tw-mb-[66px] tw-flex tw-justify-center tw-gap-5">
        {SLIDER_DATA?.map((data) => {
          return (
            <div className="tw-flex tw-max-w-[280px] tw-flex-col">
              <div className="tw-overflow-hidden">
                <img className="tw-h-full tw-w-full tw-rounded-t-2xl" src={data.url} height={228} />
              </div>
              <div
                className="tw-flex tw-items-center tw-justify-center tw-rounded-b-2xl tw-bg-white tw-py-5 tw-px-2 tw-font-jakarta tw-text-[xs] desktop:tw-text-[14px] tw-font-semibold"
                style={{ boxShadow: "0px 4px 14px 0px #0000000F" }}
              >
                <span className="tw-text-center">{data.text}</span>
              </div>
            </div>
          );
        })}
      </section>
      <section className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-8">
        <div>
          <button
            className="tw-rounded-lg tw-border tw-border-solid tw-border-[#0E0E0E] tw-bg-black tw-px-[155px] tw-py-[22px] tw-font-jakarta tw-font-semibold tw-text-white"
            onClick={requestToCallbackBtnClick}
          >
            Request a callback
          </button>
        </div>
        <div className="tw-font-jakarta tw-text-base">
          <span className="tw-font-semibold">Need Help?</span>{" "}
          <span className="tw-font-medium">Call our expert support team at {CUSOMER_SUPPORT_CONTACT_DETAILS}</span>
        </div>
      </section>
    </div>
  );
};

export default BusinessTools;
